export const PRAT_TOOLS = [
  { path: "/besoins", fr: "Évaluation des besoins psychologiques", es: "Evaluación de las necesidades psicológicas" },
  { path: "/besoins-couple", fr: "Besoins psychologiques — version couple", es: "Necesidades psicológicas — versión pareja" },
  { path: "/cope-28", fr: "Stratégies de coping (COPE-28)", es: "Estrategias de afrontamiento (COPE-28)" },
  { path: "/diva5", fr: "DIVA-5 — préparation TDAH adulte", es: "DIVA-5 — preparación TDAH adulto" },
  { path: "/conners3", fr: "Conners 3 — échelle parent", es: "Conners 3 — escala para padres" },
  { path: "/guide-tdah", fr: "Guide pratique TDAH — parents & enseignants", es: "Guía práctica TDAH — padres y docentes" },
  { path: "/boite-outils-tdah", fr: "Boîte à outils TDAH — préconisations scolaires", es: "Caja de herramientas TDAH — recomendaciones escolares" },
  { path: "/sujets-therapeutiques", fr: "Mes sujets thérapeutiques — préparation de séance", es: "Mis temas terapéuticos — preparación de sesión" },
  { path: "/autogratification", fr: "Mon autogratification — rendez-vous quotidien", es: "Mi autogratificación — cita diaria" },
  { path: "/assq", fr: "ASSQ — repérage TSA enfant (parent)", es: "ASSQ — cribado TEA infantil (padres)" },
  { path: "/idr-50", fr: "Inventaire des Drivers Relationnels", es: "Inventario de Drivers Relacionales" },
  { path: "/qicm-20", fr: "Insight Cognitif et Métacognition (QICM-20)", es: "Insight Cognitivo y Metacognición (QICM-20)" },
  { path: "/empathie", fr: "Ce que je crois savoir de nous (à deux)", es: "Lo que creo entender de nosotros (en pareja)" },
  { path: "/drivers-exo", fr: "Cahier d'exercices — Drivers relationnels", es: "Cuaderno de ejercicios — Drivers relacionales" },
  { path: "/schemas-pensees", fr: "Cahier de mes pensées automatiques", es: "Cuaderno de mis pensamientos automáticos" },
  { path: "/programme-3-semaines", fr: "Programme 3 semaines — 5 min/jour", es: "Programa de 3 semanas — 5 min/día" },
];

export const PATIENT_MODULES = [
  { key: "besoins", fr: "Évaluation des besoins psychologiques", es: "Evaluación de las necesidades psicológicas" },
  { key: "cope-28", fr: "Stratégies de coping (COPE-28)", es: "Estrategias de afrontamiento (COPE-28)" },
  { key: "idr-50", fr: "Inventaire des Drivers Relationnels", es: "Inventario de Drivers Relacionales" },
  { key: "qicm-20", fr: "Insight Cognitif et Métacognition (QICM-20)", es: "Insight Cognitivo y Metacognición (QICM-20)" },
  { key: "drivers-exo", fr: "Cahier d'exercices — Drivers relationnels", es: "Cuaderno de ejercicios — Drivers relacionales" },
  { key: "empathie", fr: "Ce que je crois savoir de nous (à deux)", es: "Lo que creo entender de nosotros (en pareja)" },
  { key: "connais", fr: "Est-ce que je te connais vraiment ? (à deux)", es: "¿Te conozco de verdad? (en pareja)" },
  { key: "besoins-couple", fr: "Besoins psychologiques — version couple", es: "Necesidades psicológicas — versión pareja" },
  { key: "schemas-pensees", fr: "Cahier de mes pensées automatiques", es: "Cuaderno de mis pensamientos automáticos" },
  { key: "programme-3-semaines", fr: "Programme 3 semaines — 5 min/jour", es: "Programa de 3 semanas — 5 min/día" },
  { key: "diva5", fr: "DIVA-5 — préparation de l'entretien TDAH adulte", es: "DIVA-5 — preparación de la entrevista TDAH adulto" },
  { key: "conners3", fr: "Conners 3 — échelle pour le parent", es: "Conners 3 — escala para el padre/la madre" },
  { key: "guide-tdah", fr: "Guide pratique TDAH — parents & enseignants", es: "Guía práctica TDAH — padres y docentes" },
  { key: "boite-outils-tdah", fr: "Boîte à outils TDAH — préconisations scolaires", es: "Caja de herramientas TDAH — recomendaciones escolares" },
  { key: "sujets-therapeutiques", fr: "Mes sujets thérapeutiques — préparation de séance", es: "Mis temas terapéuticos — preparación de sesión" },
  { key: "autogratification", fr: "Mon autogratification — rendez-vous quotidien", es: "Mi autogratificación — cita diaria" },
  { key: "assq", fr: "ASSQ — questionnaire de repérage TSA (parent)", es: "ASSQ — cuestionario de cribado TEA (padres)" },
  { key: "super-cerveau", fr: "Mission « Super-Cerveau » — jeu enfant-parent (TDAH)", es: "Misión « Súper-Cerebro » — juego niño-padres (TDAH)" },
];

export const PRAT_T = {
  fr: {
    espacePraticien: "Espace praticien",
    backHome: "← Retour à l'accueil",
    loginTitle: "Connexion praticien",
    loginSub: "Accès réservé. Identifiez-vous pour accéder à vos outils.",
    emailLabel: "Adresse e-mail",
    passwordLabel: "Mot de passe",
    loginBtn: "Se connecter",
    signing: "Connexion…",
    forgotLink: "Mot de passe oublié ?",
    forgotTitle: "Mot de passe oublié",
    forgotSub: "Saisissez votre e-mail pour afficher votre question de récupération.",
    getQuestion: "Continuer",
    answerLabel: "Votre réponse",
    newPasswordLabel: "Nouveau mot de passe",
    resetBtn: "Réinitialiser le mot de passe",
    resetting: "Réinitialisation…",
    resetSuccess: "Mot de passe réinitialisé. Vous pouvez vous connecter.",
    backToLogin: "← Retour à la connexion",
    dashboardTitle: "Nos outils cliniques",
    dashboardIntro: "Sélectionnez un questionnaire, un cahier, un guide ou le jeu à proposer. Aucune donnée n'est archivée : chaque passation reste confidentielle et locale.",
    ficheTitle: "Fiches de suivi patient",
    ficheDesc: "Créez et suivez vos fiches patients : séances, objectifs, thématiques, programme personnalisé et attestation. Données archivées, visibles par vous seul.",
    ficheOpen: "Ouvrir les fiches de suivi",
    logout: "Se déconnecter",
    openTool: "Ouvrir",
    loading: "Chargement…",
    errorGeneric: "Une erreur est survenue. Réessayez.",
    patientLinksTitle: "Liens à envoyer aux patients",
    patientLinksIntro: "Générez un lien direct à envoyer à un patient. Il ouvrira le questionnaire sans aucun accès à votre espace. Aucune donnée n'est archivée : le patient voit et exporte lui-même son résultat.",
    patientNameLabel: "Prénom ou code du patient (optionnel)",
    patientNamePlaceholder: "Ex. Marie, ou un code de suivi",
    linkLangLabel: "Langue du questionnaire :",
    copyPatientLink: "Copier le lien patient",
    linkCopied: "Lien patient copié",
    copyError: "Impossible de copier le lien",
    openNewTab: "Ouvrir",
    showQr: "QR code",
    hideQr: "Masquer le QR",
    qrHint: "À montrer ou imprimer pour votre patient",
    infosTitle: "Informations pratiques (accès au cabinet)",
    infosDesc: "Une page prête à partager : adresse, codes d'accès et salle d'attente, avec export PDF pour le patient.",
    infosOpen: "Ouvrir la page",
    infosCopy: "Copier le lien",
  },
  es: {
    espacePraticien: "Espacio del profesional",
    backHome: "← Volver al inicio",
    loginTitle: "Acceso del profesional",
    loginSub: "Acceso reservado. Identifícate para acceder a tus herramientas.",
    emailLabel: "Correo electrónico",
    passwordLabel: "Contraseña",
    loginBtn: "Iniciar sesión",
    signing: "Conectando…",
    forgotLink: "¿Contraseña olvidada?",
    forgotTitle: "Contraseña olvidada",
    forgotSub: "Introduce tu correo para mostrar tu pregunta de recuperación.",
    getQuestion: "Continuar",
    answerLabel: "Tu respuesta",
    newPasswordLabel: "Nueva contraseña",
    resetBtn: "Restablecer la contraseña",
    resetting: "Restableciendo…",
    resetSuccess: "Contraseña restablecida. Ya puedes iniciar sesión.",
    backToLogin: "← Volver al inicio de sesión",
    dashboardTitle: "Nuestras herramientas clínicas",
    dashboardIntro: "Selecciona un cuestionario para administrar. No se archiva ningún dato: cada pasación es confidencial y local.",
    ficheTitle: "Fichas de seguimiento del paciente",
    ficheDesc: "Cree y realice el seguimiento de sus fichas de pacientes: sesiones, objetivos, temáticas, programa personalizado y certificado. Datos archivados, visibles solo para usted.",
    ficheOpen: "Abrir las fichas de seguimiento",
    logout: "Cerrar sesión",
    openTool: "Abrir",
    loading: "Cargando…",
    errorGeneric: "Se ha producido un error. Inténtalo de nuevo.",
    patientLinksTitle: "Enlaces para enviar a los pacientes",
    patientLinksIntro: "Genera un enlace directo para enviar a un paciente. Abrirá el cuestionario sin ningún acceso a tu espacio. No se archiva ningún dato: el paciente ve y exporta su propio resultado.",
    patientNameLabel: "Nombre o código del paciente (opcional)",
    patientNamePlaceholder: "Ej. María, o un código de seguimiento",
    linkLangLabel: "Idioma del cuestionario:",
    copyPatientLink: "Copiar el enlace del paciente",
    linkCopied: "Enlace del paciente copiado",
    copyError: "No se puede copiar el enlace",
    openNewTab: "Abrir",
    showQr: "Código QR",
    hideQr: "Ocultar el QR",
    qrHint: "Para mostrar o imprimir a tu paciente",
    infosTitle: "Información práctica (acceso al gabinete)",
    infosDesc: "Una página lista para compartir: dirección, códigos de acceso y sala de espera, con exportación en PDF para el paciente.",
    infosOpen: "Abrir la página",
    infosCopy: "Copiar el enlace",
  },
};
